export class MiscFns {
  static arraysEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  static humanReadableAge(unix_timestamp) {
    const age_in_seconds = Math.floor(Date.now() / 1000 - unix_timestamp);
    return this.humanReadableDuration(age_in_seconds) + " ago";
  }

  static humanReadableDuration(seconds) {
    if (seconds < 100) {
      if (seconds === 1) {
        return "1 second";
      } else {
        return seconds + " seconds";
      }
    }
    seconds = Math.floor(seconds);
    if (seconds < 120) {
      if (seconds === 1) {
        return "1 second";
      } else {
        return seconds + " seconds";
      }
    }

    const minutes = Math.round(seconds / 60);
    if (minutes < 120) {
      return minutes + " minutes";
    }

    const hours = Math.round(minutes / 60);
    if (hours < 48) {
      return hours + " hours";
    }

    const days = Math.round(hours / 24);
    return days + " days";
  }

  static getUnixTimeFromTimeString(timeString) {
    return new Date(timeString).getTime() / 1000;
  }

  static bisectLeft(arr, value) {
    let low = 0;
    let high = arr.length;
    while (low < high) {
      const middle = (low + high) >> 1;
      if (arr[middle] < value) {
        low = middle + 1;
      } else {
        high = middle;
      }
    }
    return low;
  }

  static convertDegreesToRadians(angle) {
    return (angle * Math.PI) / 180;
  }
}

export function ensureDateIsMillis(input) {
  if (typeof input === "number") {
    return input;
  }
  return MiscFns.getUnixTimeFromTimeString(input) * 1000;
}

export function parseDateParam(input) {
  if (input == null || input === undefined || input === "" || input === null) {
    return null;
  }
  return parseInt(input);
}

export function binarySearch(arrayToSearch, key) {
  let low = 0;
  let high = arrayToSearch.length - 1;
  while (low <= high) {
    let k = (high + low) >> 1;
    let cmp = key - arrayToSearch[k];
    if (cmp > 0) {
      low = k + 1;
    } else if (cmp < 0) {
      high = k - 1;
    } else {
      return k;
    }
  }
  return ~low;
}

export function translateClinicalEventKey(key) {
  switch (key.toLowerCase()) {
    case "drainage_start":
      return "Start Drainage";
    case "drip":
      return "Drop";
    case "displayed_icp_update":
      return "Displayed ICP Update";
    case "drainage_end":
      return "Stop Drainage";
    case "waveform_paused":
      return "Waveform Paused";

    case "alarm_assert":
      return "Alarm";
    case "alarm_deassert":
      return "Alarm Cleared";
    case "alarm_mute":
      return "Alarm Muted";
    case "alarm_acknowledge":
      return "Alarm Acknowledged";
    case "alarm_autoclamp_request":
      return "Autoclamp Requested";
    case "alarm_autoclamp_release":
      return "Autoclamp Released";
    case "autoclamp_begin":
      return "Autoclamp Start";
    case "autoclamp_end":
      return "Autoclamp Stop";
    case "annotation-position_change":
      return "Position Change";
    case "annotation-icp_change":
      return "ICP Change";
    case "annotation-waveform_manipulation":
      return "Waveform Manipulation";
    case "annotation-troubleshooting_start":
      return "Troubleshooting Start";
    case "annotation-troubleshooting_stop":
      return "Troubleshooting Stop";
    case "annotation-other":
      return "CA - Other";
    case "annotation-medication":
      return "Medication";
    case "annotation-catheter_issue":
      return "Catheter Issue";
    case "annotation-troubleshoot":
      return "Troubleshoot";
    case "annotation-csf_color":
      return "CSF Color";
    case "annotation-csf_sample":
      return "CSF Sample";
    case "settings_change":
      return "Settings Change";
    case "reg_mode-regulation_mode_pressure":
      return "Session Start (Pressure)";
    case "reg_mode-regulation_mode_volume_top_of_hour":
      return "Session Start (Volume - Top of Hour)";
    case "reg_mode-regulation_mode_volume_continuous":
      return "Session Start (Volume - Continuous)";
    // case "1_0":
    //   return "Preset 1 Selected";
    // case "1_1":
    //   return "Preset 1 Selected";
    // case "1_2":
    //   return "Preset 1 Selected";
    // case "1_3":
    //   return "Preset 1 Selected";
    case "alarm_autoclamp_request-volume_sensing_error":
      return "Autoclamp (Volume Sensing Error)";
    case "alarm_autoclamp_release-volume_sensing_error":
      return "Stop Autoclamp (Volume Sensing Error)";
    default:
      return "Unknown (" + key + ")";
  }
}
